export default __webpack_public_path__ + "static/media/pictogramMoneyIn48.9703be3b.svg";